import {copyText} from '@github-ui/copy-to-clipboard'
import {CopyIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps, merge} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {useCallback} from 'react'

export type ActionListItemCopyToClipboardProps = {
  /** The content intended to be copied to the clipboard. */
  textToCopy: string
} & Omit<ActionListItemProps, 'onSelect'>

export function ActionListItemCopyToClipboard({
  textToCopy,
  children,
  sx: externalSx,
  ...props
}: ActionListItemCopyToClipboardProps) {
  const defaultStyles = {}
  const styles = externalSx ? merge<BetterSystemStyleObject>(defaultStyles, externalSx) : defaultStyles
  const onSelect = useCallback(async () => {
    await copyText(textToCopy)
  }, [textToCopy])

  return (
    <ActionList.Item onSelect={onSelect} {...props} sx={styles}>
      <ActionList.LeadingVisual>
        <CopyIcon />
      </ActionList.LeadingVisual>
      {children}
    </ActionList.Item>
  )
}

try{ ActionListItemCopyToClipboard.displayName ||= 'ActionListItemCopyToClipboard' } catch {}